import * as Yup from 'yup';
import { EMPTY_GROUP_ID } from '../constants';
import { GroupSchema } from 'lumas-shared-schemas';

const maxGroupNameLength = GroupSchema.shape.name.maxLength;    // pull max group length from canonical schema

// Group ID validation schema
const groupIDSchema = Yup.object().shape({
    groupID: Yup.string()
    .min(6, 'Group ID must be at least 6 characters')
    .matches(/[a-zA-Z]/, 'Group ID must contain at least one letter')
    .matches(/[0-9]/, 'Group ID must contain at least one number')
    .required('Group ID is required'),
});

// Group name validation schema
const groupNameSchema = Yup.object().shape({
    name: Yup.string()
    .min(3, 'Group name must be at least 3 characters')
    .max(maxGroupNameLength, 'Group name must be at most 20 characters')
    .required('Group name is required')
    .notOneOf([EMPTY_GROUP_ID], 'Group name cannot be None'), // Ensure that the group name cannot equal the empty group ID
});

// Heart name validation schema
const heartNameSchema = Yup.object().shape({
    name: Yup.string()
    .min(3, 'Heart name must be at least 3 characters')
    .max(24, 'Heart name must be at most 24 characters')
    .required('Heart name is required'),
});

// Login - email and password validation schema
const loginSchema = Yup.object().shape({
    // username: Yup.string()
    // .min(3, 'Username must be at least 3 characters')
    // .max(100, 'Username must be at most 100 characters')
    // .required('Username is required'),
    email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
    password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
});

// Sign up - username, email and password validation schema
const signUpSchema = Yup.object().shape({
    username: Yup.string()
    .min(3, 'Username must be at least 3 characters')
    .max(100, 'Username must be at most 100 characters')
    .required('Username is required'),
    email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
    password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
});

// Reset password schema - email
const resetPasswordSchema = Yup.object().shape({
    email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
});

export {groupIDSchema, groupNameSchema, heartNameSchema, loginSchema, signUpSchema, resetPasswordSchema}